/**
 * Plan type card data for the landing page Plan Types section.
 *
 * Each entry maps to an i18n key prefix under the `landing:planTypes`
 * namespace and an image key in {@link LANDING_IMAGES}.
 *
 * @module landing/content/plan-types
 */

import type { LANDING_IMAGES } from './images';

/** Describes a single plan type card. */
export interface PlanTypeItem {
  /** Unique identifier for the plan type. */
  id: string;
  /** i18n key prefix under `landing:planTypes` (e.g. "medical"). */
  i18nKey: string;
  /** Key in LANDING_IMAGES for the card image. */
  imageKey: keyof typeof LANDING_IMAGES;
}

/** Plan types displayed on the landing page. */
export const PLAN_TYPES: PlanTypeItem[] = [
  { id: 'medical', i18nKey: 'medical', imageKey: 'medical' },
  { id: 'dental', i18nKey: 'dental', imageKey: 'dental' },
  { id: 'vision', i18nKey: 'vision', imageKey: 'vision' },
  { id: 'pharmacy', i18nKey: 'pharmacy', imageKey: 'pharmacy' },
];
